import React from "react";
import { Route, Redirect } from "react-router-dom";
import store from "../store";

const AuthenticatedRoute = ({ component: C, isAuthenticated, ...rest }) => {
  const auth = store.getState().authState;
  if ((!auth.userData?.is_superuser && rest.location.pathname === '/staff/welcome') || (!auth.userData?.is_superuser && rest.location.pathname === '/staff/release') || (!auth.userData?.is_superuser && rest.location.pathname === '/staff/promo')) {
    return <Redirect to={'/'}/>
  } else {
    return (<Route
        {...rest}
        render={props =>
            isAuthenticated
                ? <C {...props} />
                : <Redirect to={`/login?redirect=${props.location.pathname}${props.location.search}`}/>}
    />)
  }
}

export default AuthenticatedRoute;
